import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Modal from '../Modal/Modal';
import Text from '../Text/Text';
import CustomSelect from '../Select/CustomSelect';
import getRoles from '../../thunks/roles/getRoles';
import Alert from '../Alert/Alert';
import alertType from '../../common/alertType';
import patchUserRole from '../../thunks/users/patchUserRole';
import getRoleDetails from '../../thunks/roles/getRoleDetails';

const ChangeUserRoleModal = ({
  visible, toggleVisible, currentRoleId, userId
}) => {
  const [selectedRole, setSelectedRole] = useState();
  const dispatch = useDispatch();
  const { getRoles: { roles } = {}, patchUserRole: { loading, error, updated } } = useSelector((state) => ({
    getRoles: state.getRoles,
    patchUserRole: state.patchUserRole
  }), shallowEqual);

  useEffect(() => {
    if (!roles) {
      dispatch(getRoles());
    }
  }, [roles]);

  const roleList = roles?.map(({ name, id }) => ({ label: name, value: id }));

  const defaultValue = roles
    ?.filter(({ id }) => id === currentRoleId)
    ?.map(({ name, id }) => ({ label: name, value: id }));

  const onSave = () => dispatch(patchUserRole({ userId, roleId: selectedRole?.value }));

  useEffect(() => {
    if (updated && currentRoleId) {
      dispatch(getRoleDetails(currentRoleId));
      toggleVisible();
    }
  }, [updated]);

  return (
    <Modal
      visible={visible}
      toggleVisible={toggleVisible}
      title="Change role"
      canSave={!selectedRole && !loading}
      onSave={onSave}
    >
      <div>
        <Text text="New role:" styleContainer="mb-[5px]" textStyle="text-[13px]" required />
        <CustomSelect options={roleList || []} defaultValue={defaultValue?.[0]} onChange={setSelectedRole} />
        <br />
        {error && <Alert text={error} type={alertType.warning} />}
      </div>
    </Modal>
  );
};

ChangeUserRoleModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
  currentRoleId: PropTypes.number,
  userId: PropTypes.number,
};

ChangeUserRoleModal.defaultProps = {
  toggleVisible: () => {},
  visible: false,
  currentRoleId: undefined,
  userId: undefined
};

export default ChangeUserRoleModal;
